import React from "react";
import { Col, Row, Container } from "reactstrap";
import { Card, CardBody } from "reactstrap";
import { Link } from "react-router-dom"; // Assuming you're using react-router

import arrow from "../../assets/images/card_images/arrow.png";
import boat_owner from "../../assets/images/boat_owner01.png";
import processing_plant from "../../assets/images/processing_plant01.png";
import courier from "../../assets/images/courier01.png";
import "./card.css";

const Offer = () => {
  // Function to handle button click and set localStorage
  const handleRegisterClick = (userType) => {
    localStorage.setItem("registrationType", userType);
  };

  return (
    <React.Fragment>
      <section className="bg-light register-section-tab">
        <Container
          fluid
          className="bg-light"
        >
          <Row className="gaps">
            <Col
              md={3}
              className="p-1"
            >
              <Card className="custom-card1 d-flex flex-column h-100">
                <CardBody className="card-body d-flex flex-column">
                  <div
                    className="card-content flex-grow-1"
                    style={{ zIndex: '200' }}
                  >
                    <img
                      src={arrow}
                      className="arrow"
                    />
                    <div className="card-text-div">
                      <h5 className="card-title2">Register as Buyer</h5>
                      <p className="card-text2"></p>
                    </div>
                  </div>
                  <Link
                    to="/signup"
                    style={{ zIndex: '200' }}
                  >
                    <button
                      className="explore-button w-auto align-self-start"
                      onClick={() => handleRegisterClick('buyer')}
                    >
                      Register Now
                    </button>
                  </Link>
                </CardBody>
              </Card>
            </Col>
            <Col
              md={3}
              className="p-1"
            >
              <Card className="custom-card2 d-flex flex-column h-100">
                <CardBody className="card-body d-flex flex-column">
                  <div
                    className="card-content flex-grow-1"
                    style={{ zIndex: '200' }}
                  >
                    <img
                      src={arrow}
                      className="arrow"
                    />
                    <div className="card-text-div">
                      <h5 className="card-title2">Register as Boat Owner</h5>
                      <p className="card-text2"></p>
                    </div>
                  </div>
                  <Link
                    to="/signup"
                    style={{ zIndex: '200' }}
                  >
                    <button
                      className="explore-button w-auto align-self-start"
                      onClick={() => handleRegisterClick('boat_owner')}
                    >
                      Register Now
                    </button>
                  </Link>
                </CardBody>
              </Card>
            </Col>
            <Col
              md={3}
              className="p-1"
            >
              <Card className="custom-card3 d-flex flex-column h-100">
                <CardBody className="card-body d-flex flex-column">
                  <div
                    className="card-content flex-grow-1"
                    style={{ zIndex: '200' }}
                  >
                    <img
                      src={arrow}
                      className="arrow"
                    />
                    <div className="card-text-div">
                      <h5 className="card-title2">
                        Register as Processing Plant
                      </h5>
                      <p className="card-text2"></p>
                    </div>
                  </div>
                  <Link
                    to="/signup"
                    style={{ zIndex: '200' }}
                  >
                    <button
                      className="explore-button w-auto align-self-start"
                      onClick={() => handleRegisterClick('processing_plant')}
                    >
                      Register Now
                    </button>
                  </Link>
                </CardBody>
              </Card>
            </Col>
            <Col
              md={3}
              className="p-1"
            >
              <Card className="custom-card4 d-flex flex-column h-100">
                <CardBody className="card-body d-flex flex-column">
                  <div
                    className="card-content flex-grow-1"
                    style={{ zIndex: '200' }}
                  >
                    <img
                      src={arrow}
                      className="arrow"
                    />
                    <div className="card-text-div">
                      <h5 className="card-title2">Register as Courier</h5>
                      <p className="card-text2"></p>
                    </div>
                  </div>
                  <Link
                    to="/signup"
                    style={{ zIndex: '200' }}
                  >
                    <button
                      className="explore-button w-auto align-self-start"
                      onClick={() => handleRegisterClick('courier')}
                    >
                      Register Now
                    </button>
                  </Link>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default Offer;
